import {
  DateRangeFilter,
  ListFilterLayout as FiltersLayout,
  StaticFilters as Filters,
  useListContext,
} from 'framework/list';
import usePayrollReportSettings from 'domain/finance/payroll/generatedPayrolls/shared/Settings/usePayrollReportSettings';
import React from 'react';
import useGeneratedPayrollsService from 'domain/finance/payroll/generatedPayrolls/useGeneratedPayrollsService';
import { Box } from '@mui/material';
import { SxProps } from '@mui/system';
import { Theme } from '@mui/material/styles';
import { MAX_SM_WIDTH, useDeviceDetectorService, useDidUpdateEffect } from 'framework/utils';
import { FloatingPlacement } from 'framework/ui/uiContract';
import PayrollReportSettings from 'domain/finance/payroll/generatedPayrolls/shared/Settings';

const GeneratedPayrollsStaticFilters = ({ title, sx = {} }: { title?: React.ReactNode; sx?: SxProps<Theme> }) => {
  const { getFilterValidationSchema } = useGeneratedPayrollsService();
  const { reloadData } = useListContext();
  const { isLatestReportsVisibleOnly } = usePayrollReportSettings();

  const { isDesktop } = useDeviceDetectorService({
    maxWidth: MAX_SM_WIDTH,
    defaultValue: window.innerWidth > MAX_SM_WIDTH,
  });

  useDidUpdateEffect(() => {
    if (reloadData) {
      reloadData();
    }
  }, [isLatestReportsVisibleOnly]);

  const filters = (
    <Filters getValidationSchema={getFilterValidationSchema}>
      <FiltersLayout>
        <DateRangeFilter
          key={`generated-payrolls-period-filter-${isDesktop}`}
          popperPlacement={isDesktop ? FloatingPlacement.BOTTOM_END : FloatingPlacement.BOTTOM_START}
          label="Period"
          source="period"
          canBeInFuture
        />
      </FiltersLayout>
    </Filters>
  );

  return (
    <Box
      sx={{
        [`@media (min-width: ${MAX_SM_WIDTH}px)`]: {
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
        },
        '& [data-testId="remove-btn"], & .filters-reset-btn': {
          display: 'none',
        },
        '.button-dropdown__toggle': {
          minHeight: '36px',
          padding: '5px 12px',
        },
        '.filter-item-wrapper': {
          marginRight: 0,
        },
        '.dropdown-toggle': {
          marginLeft: '8px',
          transform: 'translateY(-2px)',
        },
        '.payroll-report-settings-item': {
          minWidth: '310px',
        },
        ...sx,
      }}
    >
      {title}
      <div>
        {filters}
        <PayrollReportSettings />
      </div>
    </Box>
  );
};

export default GeneratedPayrollsStaticFilters;
